import React from 'react'
import { Button, Container, Header } from 'semantic-ui-react';
import { AiOutlineMail, AiOutlineLinkedin, AiFillGithub } from "react-icons/ai";
import Resume from "../../assets/images/BarbaraResume.pdf";
import { ImProfile } from "react-icons/im";
import './style.css';

const emailBtn = {
  background: '#9acbe2',
  color: '#fff',
}

const linkedBtn = {
  background: '#f8b3bd',
  color: '#fff',
}

const gitBtn = {
  background: '#b59ad6',
  color: '#fff',
}

const resumeBtn = {
  background: '#f6a179',
  color: '#fff',
}

function ContactForm() {
  return (
    
    <div className="contact-page">
      <div className="heading-name" >
        <Header as='h2' textAlign='center'
          className="main-name center aligned header" >Contact Me
        </Header>
      </div>
      <div className="contact-text">
        Feel free to reach out if you'd like to discuss more about my passions, skills or experience! 
        Click the links below to find out more about myself.
        </div>
      <div className="contact-icons">
        <Button style={emailBtn}
          a href="mailto:barbarap095@gmail.com"
            target="_blank">
          <AiOutlineMail className="icons-contact"/>
        </Button>

        <Button style={linkedBtn}
          a href="https://www.linkedin.com/in/barbara-potiriadis/"
            target="_blank">
          <AiOutlineLinkedin className="icons-contact"/>
        </Button>

        <Button style={gitBtn}
          a href="https://github.com/barbara095/"
            target="_blank">
          <AiFillGithub className="icons-contact"/>
        </Button>

        <Button style={resumeBtn}
          a href={Resume} target="_blank">
          <ImProfile className="icons-contact"/>Resume
        </Button>
      </div>
    </div>

  )
}

export default ContactForm;